import { Component } from '@angular/core';

@Component({
    selector: 'vc-progress-spinner',
    templateUrl: './progress-spinner.component.html',
    styleUrls: ['./progress-spinner.component.scss'],
})
export class ProgressSpinnerComponent {}
